import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`We appreciate your contribution and hope that this document helps you along the way. If you have any questions or problems, don't hesitate to `}<a parentName="p" {...{
        "href": "https://github.com/primer/doctocat/issues/new"
      }}>{`file an issue`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p>{`These guidelines are for contributing to the theme itself, if you are looking for help running a Doctocat site for another project locally, check out the `}<a parentName="p" {...{
          "href": "/usage/local-development"
        }}>{`Local Development`}</a>{` docs in the Usage section.`}</p>
    </Note>
    <h2>{`Local development`}</h2>
    <p>{`Run the following commands to begin local development:`}</p>
    <Note mdxType="Note">
      <p>{`These steps require `}<a parentName="p" {...{
          "href": "https://nodejs.org"
        }}>{`Node.js`}</a>{` and `}<a parentName="p" {...{
          "href": "https://docs.npmjs.com/downloading-and-installing-node-js-and-npm"
        }}>{`npm`}</a>{` to be set up locally.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`# Clone the repository
git clone https://github.com/primer/doctocat.git
cd doctocat

# Install the dependencies
npm install

# Start the development server for the documentation site
npm start

# Navigate to http://localhost:8000 in your browser
`}</code></pre>
    <h2>{`File structure`}</h2>
    <pre><code parentName="pre" {...{}}>{`.
├── theme/
├── docs/
└── package.json
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`theme/`}</inlineCode>{`: This directory contains the code for the `}<a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/themes/what-are-gatsby-themes/"
        }}>{`Gatsby Theme`}</a>{` and is what gets published to npm.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`docs/`}</inlineCode>{`: This directory contains the code for the documentation site for Doctocat. The documentation site can also be used to test changes to the theme locally.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`package.json`}</inlineCode>{`: This file defines the `}<a parentName="li" {...{
          "href": "https://docs.npmjs.com/cli/v7/using-npm/workspaces"
        }}>{`workspaces`}</a>{` for the project and is not meant to be published.`}</li>
    </ul>
    <h2>{`Scripts`}</h2>
    <p>{`The documentation site has a few `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/misc/scripts"
      }}>{`npm scripts`}</a>{` for developing and building the site. You can run these scripts from the root directory using the `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/cli/v7/using-npm/workspaces#running-commands-in-the-context-of-workspaces"
      }}><inlineCode parentName="a">{`--workspace`}</inlineCode></a>{`, or `}<inlineCode parentName="p">{`-w`}</inlineCode>{`, option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm run -w docs <script-name>
`}</code></pre>
    <h3><inlineCode parentName="h3">{`develop`}</inlineCode></h3>
    <p>{`Starts Gatsby's hot-reloading development environment on http://localhost:8000. This is likely the only script you will run manually.`}</p>
    <h3><inlineCode parentName="h3">{`build`}</inlineCode></h3>
    <p>{`Builds the site for deployment and places the output in `}<inlineCode parentName="p">{`public/`}</inlineCode>{`.`}</p>
    <h3><inlineCode parentName="h3">{`now-build`}</inlineCode></h3>
    <p>{`Builds the site for `}<a parentName="p" {...{
        "href": "https://zeit.co/now"
      }}>{`Now`}</a>{` deployment. You will never have to run `}<inlineCode parentName="p">{`now-build`}</inlineCode>{` manually. Check out the `}<a parentName="p" {...{
        "href": "https://zeit.co/docs/v2/advanced/builders/static-build-now-static-build"
      }}><inlineCode parentName="a">{`@now/static-build`}</inlineCode>{` docs`}</a>{` for more information.`}</p>
    <h2>{`Bug reports`}</h2>
    <p>{`Guidelines for bug reports:`}</p>
    <ol>
      <li parentName="ol">{`Use the GitHub issue search – check if the issue has already been reported.`}</li>
      <li parentName="ol">{`Check if the issue has been fixed – try to reproduce it using the latest version of the extension.`}</li>
      <li parentName="ol">{`Isolate the problem – find a way to demonstrate your issue. Provide either screenshots or code samples to show you problem.`}</li>
    </ol>
    <p>{`A good bug report shouldn't leave others needing to chase you down for more information. Please try to be as detailed as possible in your report.`}</p>
    <ul>
      <li parentName="ul">{`What is your environment?`}</li>
      <li parentName="ul">{`What steps will reproduce the issue?`}</li>
      <li parentName="ul">{`What browser(s) versions experience the problem?`}</li>
      <li parentName="ul">{`What would you expect to be the outcome?`}</li>
    </ul>
    <p>{`All these details will help people to fix any potential bugs.`}</p>
    <p>{`Example:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Short and descriptive example bug report title`}</p>
      <p parentName="blockquote">{`A summary of the issue and the browser/OS environment in which it occurs. If suitable, include the steps required to reproduce the bug.`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`This is the first step`}</li>
        <li parentName="ol">{`This is the second step`}</li>
        <li parentName="ol">{`Further steps, etc.`}</li>
        <li parentName="ol">{`Attach screenshots, etc.`}</li>
      </ol>
      <p parentName="blockquote">{`Any other information you want to share that is relevant to the issue being reported.`}</p>
    </blockquote>
    <h2>{`Feature requests`}</h2>
    <p>{`Feature requests are welcome. But take a moment to find out whether your idea fits with the scope and aims of the project. It's up to `}<em parentName="p">{`you`}</em>{` to make a strong case to convince the project's developers of the merits of this feature.
Please provide as much detail and context as possible.`}</p>
    <h2>{`Pull requests`}</h2>
    <p>{`Good pull requests - patches, improvements, new features - are a fantastic help.
They should remain focused in scope and avoid containing unrelated commits.`}</p>
    <p><strong parentName="p">{`Please ask first`}</strong>{` before embarking on any significant pull request (e.g. implementing features, refactoring code),
otherwise you risk spending a lot of time working on something that the project's developers might not want to merge into the project.`}</p>
    <p>{`Please adhere to the coding conventions used throughout a project (indentation, accurate comments, etc.) and any other requirements (such as test coverage).`}</p>
    <p>{`Follow this process if you'd like your work considered for inclusion in the project:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://help.github.com/fork-a-repo/"
          }}>{`Fork`}</a>{` the project, clone your fork, and configure the remotes:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`# Clone your fork of the repository
git clone https://github.com/<your-username>/doctocat

# Navigate to the newly cloned directory
cd doctocat

# Assign the original repo to a remote called "upstream"
git remote add upstream https://github.com/primer/doctocat
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you cloned a while ago, get the latest changes from upstream:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`git checkout master
git pull upstream master
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Create a new topic branch (off of the `}<inlineCode parentName="p">{`master`}</inlineCode>{` branch) to contain your feature, change, or fix:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`git checkout -b <topic-branch-name>
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Install the dependencies:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`npm i
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Start Gatsby's hot-reloading development environment:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`npm start
# The documentation site will now be accessible from http://localhost:8000
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Commit your changes in logical chunks. You can use Git's `}<a parentName="p" {...{
            "href": "https://help.github.com/articles/interactive-rebase"
          }}>{`interactive rebase`}</a>{` feature to tidy up your commits before making them public.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Locally merge (or rebase) the upstream development branch into your topic branch:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`git pull [--rebase] upstream master
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Push your topic branch up to your fork:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell"
          }}>{`git push origin <topic-branch-name>
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://help.github.com/articles/using-pull-requests/"
          }}>{`Open a Pull Request`}</a>{` with a clear title and description.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      